// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f0a1beb7","732":"333bbfc0","977":"bb3100eb"}[chunkId] + ".chunk.js";
};